import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { useTranslations } from "next-intl";

import { profileConst } from "modules/cabinet";

import { $api, errorHandler } from "..";

export const useSaveSubject = (onClose?: () => void) => {
  const queryClient = useQueryClient();
  const t = useTranslations();

  return useMutation({
    mutationFn: async (userData: Partial<any>) => {
      const { data } = await $api.post(`/mypage`, userData, { headers: { 'Content-Type': 'multipart/form-data' } });

      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [profileConst.queryKeys.USER_PROFILE_INFO] });
      message.success(t('saqlandi'));
      if (onClose) onClose();
    },
    onError: errorHandler()
  });
};
